import { Component, OnInit, Output, EventEmitter, OnDestroy, ViewChild, ElementRef, Renderer2, Inject } from "@angular/core";
import { ConfigService } from "../services/config.service";
import { Subscription } from "rxjs";
import { CustomizerService } from '../services/customizer.service';
import { AlertServices, AppServices, UserServices } from '@services';

@Component({
  selector: "app-customizer",
  templateUrl: "./customizer.component.html",
  styleUrls: ["./customizer.component.scss"]
})
export class CustomizerComponent implements OnInit, OnDestroy {
  @ViewChild("customizer") customizer: ElementRef;

  size: string;
  isBgImageDisplay: boolean = true;
  isOpen = false;
  public config: any = {};
  layoutSub: Subscription;

  constructor(
    @Inject('AlertServices') private _alertServices: AlertServices,
    @Inject('AppServices') private _appServices: AppServices,
    @Inject('UserServices') private _userServices: UserServices,
    private renderer: Renderer2,
    private configService: ConfigService,
    public customizerService: CustomizerService,
  ) {

    this.config = this.configService.templateConf;
    this.isOpen = !this.config.layout.customizer.hidden;

    if (this.config.layout.sidebar.size) {
      this.size = this.config.layout.sidebar.size;
    }

    //CSP.NOTES Added by CSP to listen and open Customizer via NavBar using AppServices
    _appServices.onOpenCustomizer.subscribe(() => { this.openCustomizer() });

  }

  @Output() directionEvent = new EventEmitter<Object>();

  ngOnInit() { }


  changeSidebarWidth(value) {
    this.size = value;
    this.customizerService.changeSidebarWidth(value);
  }

  toggleCustomizer() {
    if (this.isOpen) {
      this.renderer.removeClass(this.customizer.nativeElement, "open");
      this.isOpen = false;
    } else {
      this.renderer.addClass(this.customizer.nativeElement, "open");
      this.isOpen = true;
    }
  }


  //CSP.NOTES Added to emit open Customizer
  openCustomizer() {
    //When Customizer open then show the gear toggle
    this.renderer.removeClass(this.customizer.nativeElement.querySelector('.customizer-toggle'), "d-none");
    this.renderer.addClass(this.customizer.nativeElement, "open");
    this.isOpen = true;
  }






  closeCustomizer() {
    //CSP.NOTE When Customizer close then hide the gear toggle
    this.renderer.addClass(this.customizer.nativeElement.querySelector('.customizer-toggle'), "d-none");

    this.renderer.removeClass(this.customizer.nativeElement, "open");
    this.isOpen = false;
  }

  bgImageDisplay(e) {
    if (e.target.checked) {
      this.isBgImageDisplay = true;
    } else {
      this.isBgImageDisplay = false;
    }
    //emit event to FUll Layout
    this.customizerService.bgImageDisplay(e);
  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }


  SaveAppSettings() {

    console.log(this.config)

    this._userServices.saveUserSettings(this.config).subscribe((_Response) => {
      this._appServices.setAppSettings(this.config);

      this._alertServices.ShowToastMessage('success', 'app.trn-application-settings-saved-success-title', 'app.trn-application-settings-saved-success-message', true)
    }, (_error) => {
      this._alertServices.ShowToastMessage('error', 'app.trn-application-settings-saved-failed-title', 'app.trn-application-settings-saved-failed-message', true)
    });


  }

}
